'use strict';var getApiHost = function getApiHost() {
  var host = process.env.API_HOST;

  if (!host) {
    throw new Error('No API_HOST was specified');
  }

  var isLocalhost = host.indexOf('localhost') !== -1;

  if (!isLocalhost && host.indexOf('http://') === 0) {
    throw new Error('API host must be secured and use https');
  }

  if (!isLocalhost && host.indexOf('https://') !== 0) {
    return 'https://' + host;
  }

  return host;
};

module.exports = getApiHost;


//////////////////
// WEBPACK FOOTER
// ./src/utils/getApiHost.js
// module id = 3156
// module chunks = 0